import React from "react";
import { Link } from "react-router-dom";
import "../static/Sidebar.css"
function NotFound() {
    return (
        <div>
            <h1>Not Found</h1>
            <Link to="/">Home</Link>
        </div>

    )
}

export default NotFound